// extracted by mini-css-extract-plugin
export default {"root":"SplashScreen_root__bKID2","logoStrapline":"SplashScreen_logoStrapline__eqCwJ"};